import { isNull } from 'lodash';

export const normalizeStringToEmpty = (val: string | null): string => (isNull(val) ? '' : val);

export const nbspReplacer = (value: string) => {
  return !value.includes('&nbsp;') ? value : value.replaceAll('&nbsp;', '');
};
